import React from 'react';
import { Stack } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MDInput from 'components/MDInput';
import { tr } from 'date-fns/locale';

export default function DateRangeComponent({ dateRange, updateDateRange }) {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
            <Stack spacing={2}>
                <DatePicker
                    label="Başlangıç Tarihi"
                    value={dateRange?.startDate || null}
                    onChange={(date) => updateDateRange({ ...dateRange, startDate: date })}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
                <DatePicker
                    label="Bitiş Tarihi"
                    value={dateRange?.endDate || null}
                    onChange={(date) => updateDateRange({ ...dateRange, endDate: date })}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
            </Stack>
        </LocalizationProvider>
    );
}
